import { IFeatureProps } from 'mod/featureV2/interface';
import { IFeatureWaterFall } from 'mod/featureV2/interface/waterFall';
import { FeatureWaterFall as ModFeatureWaterFall } from 'mod/featureV2/FeatureWaterFall';
import styles from './index.module.less';

export function FeatureWaterFall(props: IFeatureProps<IFeatureWaterFall>): Globals.JSXRenderType {
    return (
        <ModFeatureWaterFall
            className={styles.waterfall}
            {...props}
        />
    )
}

export default FeatureWaterFall;